// (17/10/2026) Lựa chọn "mạng bị tạm dừng (CAPTCHA / xác minh…) chưa ai xử lý quá bao lâu thì tự bỏ qua, chạy mạng kế" cho lượt chạy đồ thị — dùng chung ở thẻ Chạy lượt
// (kich-ban-luot.ts) và hộp Hẹn giờ (hen-gio-so-do.ts). Giá trị "" = không gửi khoá hanChoNguoiS → máy chủ dùng mặc định (Chạy thật 30 phút). Chuỗi có ô riêng ở trang Chuỗi.
import { h } from "./dom";

export const MAC_DINH_HAN_CHO_PHUT = 30;
/** [giá trị, chữ]: giá trị là số giây ("0" = chờ mãi) hoặc "" = mặc định. */
export const LUA_CHON_HAN_CHO: [string, string][] = [
  ["", `Chờ ${MAC_DINH_HAN_CHO_PHUT} phút (mặc định)`],
  ["600", "Chờ 10 phút"],
  ["3600", "Chờ 1 giờ"],
  ["10800", "Chờ 3 giờ"],
  ["0", "Chờ mãi (không tự bỏ qua)"],
];
export const TIEU_DE_HAN_CHO = "Nick đang bị CAPTCHA / xác minh / đăng xuất trên một mạng mà quá chừng này chưa ai xử lý thì lượt TỰ BỎ QUA phần của mạng đó và chạy tiếp mạng khác (nick vẫn tạm dừng — máy không tự cho chạy lại, không tự giải CAPTCHA). Chờ mãi = không bao giờ tự bỏ qua.";

/** Ô chọn hạn chờ người; `giaTri` = hanChoNguoiS đã lưu (undefined = mặc định). */
export function taoOChonHanCho(testid: string, giaTri?: number): HTMLSelectElement {
  const o = h("select", { "data-testid": testid, "aria-label": "Mạng tạm dừng chưa ai xử lý thì tự bỏ qua sau", title: TIEU_DE_HAN_CHO },
    ...LUA_CHON_HAN_CHO.map(([v, t]) => h("option", { value: v }, t))) as HTMLSelectElement;
  // giá trị lạ (đặt qua API, vd 5400) vẫn hiện được: thêm lựa chọn riêng
  if (giaTri !== undefined && !LUA_CHON_HAN_CHO.some(([v]) => v === String(giaTri))) o.append(h("option", { value: String(giaTri) }, `Chờ ${Math.round(giaTri / 60)} phút`));
  o.value = giaTri === undefined ? "" : String(giaTri);
  return o;
}
/** Phần cấu hình gửi lên: {} khi mặc định, {hanChoNguoiS} khi người dùng chọn. */
export const hanChoTuO = (o: HTMLSelectElement): { hanChoNguoiS?: number } => (o.value === "" ? {} : { hanChoNguoiS: Number(o.value) });
